import HeaderList from "../../HeaderList";
import BodyList from "../../BodyList";
import { useIntl } from "react-intl";
import { Spin } from "antd";
import Empty from "../../../common/Empty";

const ReservationsSummary = ({ data, setPage, page, isLoading }: any) => {
  const intl = useIntl();
  const cols = [
    "location",
    intl.formatMessage({ id: "servicesCount" }), // for "services_count"
    intl.formatMessage({ id: "appointmentsCount" }), // for "appointments_count"
    intl.formatMessage({ id: "totalCost" }), // for "total_cost"
    intl.formatMessage({ id: "averageCost" }), // for "average_cost"
    intl.formatMessage({ id: "totalCostOnline" }), // for "total_cost_online"
    intl.formatMessage({ id: "totalCostCancelOnline" }), // for "total_cost_cancel_online"
  ];

  return isLoading ? (
    <Spin className="flex items-center justify-center" />
  ) : [data]?.length ? (
    <div className="overflow-auto">
      <HeaderList cols={cols} />
      <BodyList
        data={[data]}
        page={page}
        total={data?.total}
        setPage={setPage}
      />
    </div>
  ) : (
    <Empty title="لا توجد" subTitle="" />
  );
};

export default ReservationsSummary;
